import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Page } from '../../helpers/page';

import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-release-notes',
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.scss']
})
export class ReleaseNotesComponent implements OnInit, OnChanges {

    @Input()
    page: Page;

    availableTabs = [
        'releaseInfo',
        'newFeatures',
        'newEnhancements',
        'bugFixes',
        'minorChanges',
        'newMetadata'
    ];
    content: any;
    private tab: string;
    titleElement = {
        tagName: 'H1',
        innerHTML: '',
        id: 'title'
    };

    constructor(
        private activatedRoute: ActivatedRoute,
        private docsService: DocsService,
    ) { }

    ngOnChanges() {
        console.log('# DOCUMENT RECEIVED');
        this.content = this.page.content;
        this.titleElement.innerHTML = this.content.name.content;
        this.setTab(this.availableTabs[0]);
    }

    ngOnInit() {
        this.activatedRoute.fragment.subscribe(fragment => {
            if (fragment) {
                console.log('# FRAGMENT FOUND:', fragment);
                const fragmentParts = fragment.split('-');

                if (this.availableTabs.includes(fragmentParts[0]) && !this.isTab(fragmentParts[0])) {
                    this.setTab(fragmentParts[0]);
                }
            }

        });

        this.titleElement.innerHTML = this.content.name.content;
    }

    isTab(tab: string): boolean {
        return tab === this.tab;
    }

    setTab(tabName: string) {
        this.tab = tabName;
        this.docsService.emitContentChange();
    }
}
